import { toDate as e } from "./toDate.js";
function d(t) {
  return e(t).getDate();
}
export {
  d as default,
  d as getDate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getDate.js
// module id = 425
// module chunks = 41